<template>
  <router-link
    class="nav-link"
    :aria-current="isLakeFinderOpen ? 'page' : 'false'"
    :to="{ name: routeNames.WATERBODIES }"
    data-test="waterbodies"
    @click.prevent="handleLinkClick"
  >
    <ys-icon icon="ysWaterCrossing" class="nav-icon" />
    Lake Finder
  </router-link>
  <router-link
    class="nav-link"
    :to="{ name: 'fish-my-content-created' }"
    data-test="MyContentButton"
    @click.prevent="handleLinkClick"
  >
    <ys-icon icon="ysMyContentFill" class="nav-icon" />
    My Content
  </router-link>
  <router-link
    class="nav-link"
    :to="{ name: routeNames.FAVORITES_FISH }"
    data-test="waterbodies"
    @click.prevent="handleLinkClick"
  >
    <ys-icon icon="ysBookmarkFill" class="nav-icon bookmark" />
    Saved
  </router-link>
  <router-link
    v-if="showOfflineMaps()"
    id="offlineMapsNavItem"
    class="nav-link"
    :to="{ name: routeNames.OFFLINE_FISH }"
    data-test="Offline-Maps"
    @click.prevent="handleLinkClick"
  >
    <ys-icon icon="ysOfflineMaps" class="nav-icon" />

    Offline Maps
  </router-link>
  <button
    v-if="isActive('ai_guide_chat')"
    type="button"
    class="nav-link"
    aria-label="onX Guide"
    :aria-expanded="isOpen"
    @click="openOnxGuide"
  >
    <x-icon icon="lantern-onx-guide" class="nav-icon" width="25" height="25" />
    <span class="nav-link-label-stack" data-test="onx-guide-label-stack">
      <span>onX Guide</span>
      <ai-toolkit-beta-tag />
    </span>
  </button>
</template>
<!-- eslint-disable vue/block-lang -->
<script setup>
///// imports /////
import { computed } from 'vue'
import '@onxmaps/yellowstone-ui/ys-icon'
import '@onxmaps/yellowstone-ui/icons/ysMyContentFill'
import '@onxmaps/yellowstone-ui/icons/ysBookmarkFill'
import '@onxmaps/yellowstone-ui/icons/ysOfflineMaps'
import '@onxmaps/yellowstone-ui/icons/ysWaterCrossing'
import { useRoute } from 'vue-router'
import { useSideNavFunctions } from '@/composables/nav-links'
import browser from '@/lib/browser'
import routeNames from '@/fish/router/constants'
import { useAiChatCard } from '@/lib/ai/components/use-ai-chat-card'
import '@onxmaps/ai-toolkit/components/ai-toolkit-beta-tag'
import { setMobileMenuOpen } from '@/services/control-layout-service'
import { isActive } from '@/services/feature-flag-service'
import xIcon from '@/components/shared/x-icon/index.vue'

///// refs and variables /////
const { handleLinkClick } = useSideNavFunctions()
const route = useRoute()
const { isOpen, openAiChatCard } = useAiChatCard()

///// computed /////
const isLakeFinderOpen = computed(() =>
  route?.matched.some((r) => r.name === routeNames.WATERBODIES)
)

///// functions /////
const openOnxGuide = () => {
  // No title override: control-ai-chat.vue falls back to
  // dependencies.identity.agentName ("onX Guide") when config.title is
  // absent, so the branding lives in one place.
  openAiChatCard({
    event: { origin: 'navigation menu' },
  })
  setMobileMenuOpen(false)
}

const showOfflineMaps = () => {
  // Show maps for any desktop user, or mobile iOS users
  if (!browser.isMobile()) {
    return true
  }
  return browser.isiPhone() || browser.isiPad()
}
</script>
<style lang="scss" scoped>
button.nav-link {
  background: none;
  border: none;
  border-radius: 0;
  cursor: pointer;
}

.nav-link-label-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ys-spacing-50);
}

.nav-link {
  .nav-icon.bookmark {
    :deep(path) {
      fill: var(--ys-color-button-text-secondary-active);
      stroke: var(--ys-color-button-text-secondary-active);
    }
  }
  &.router-link-active {
    .nav-icon.bookmark {
      :deep(path) {
        fill: var(--ys-color-brand-primary);
        stroke: var(--ys-color-brand-primary);
      }
    }
  }
}
</style>
